const HighlightInfoType = Object.freeze({
  ANAPHORA: 'Anaphora',
  RESULT: 'Result',
  SEARCH_TERM: 'SearchTerm'
})
export default HighlightInfoType
export type HighlightInfoTypeStrings = typeof HighlightInfoType[keyof typeof HighlightInfoType]
// RESERVE BELOW
